import React, { useEffect, useState } from 'react';

import api from 'services/api';

import { useSpecSheet } from 'containers/spec-sheet';

import { Select, SelectItem } from 'components/Fields';
import Loading from '../partials/Loading';

const StyleType: React.FC = () => {
  const [items, setItems] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  const {
    data: { data },
    actions,
  } = useSpecSheet();

  const styleTypeSelected = data?.styleType;

  const getAll = async () => {
    setLoading(true);

    try {
      const list: any = await api.get('/style-types?isActive=1');
      setItems(list);
      setLoading(false);
    } catch (err) {
      console.log('err: ', err);
    }
  };

  useEffect(() => {
    getAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (newStyleType: any) => {
    if (styleTypeSelected?.id !== newStyleType.id) {
      actions.changeSpecSheetData({ styleType: newStyleType });
    }
  };

  return (
    <Select
      label="Style type"
      value={styleTypeSelected?.description}
      dataTest="style-type"
    >
      {loading ? (
        <Loading />
      ) : (
        <>
          {items?.map(({ id, description }) => (
            <SelectItem
              key={`style-type-${id}`}
              onClick={() => handleChange({ id, description })}
              isSelected={id === styleTypeSelected?.id}
              data-test={`select-item-option-style-type-${id}`}
            >
              {description}
            </SelectItem>
          ))}
        </>
      )}
    </Select>
  );
};

export default StyleType;
